import { useCallback, useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { TopographNavbar } from "../components/TopographNavbar";
import { MapOverview } from "../components/MapOverview";
import { CLIENT } from "../lib/api";
import type { Map } from "../lib/types";
import { useAuth } from "../context/AuthContext";

export function Renders() {
    const auth = useAuth();
    const [maps, setMaps] = useState<Map[]>([]);

    const listMaps = useCallback(async () => {
        if (!auth.email) return;
        try {
            const resp = await CLIENT.listMaps(auth.email);
            setMaps(resp.maps);
        } catch (err) {
            console.error("listMaps failed:", err);
        }
    }, [auth.email]);

    useEffect(() => {
        if (!auth.loggedIn) return;
        listMaps();
        const id = window.setInterval(listMaps, 10_000);
        return () => window.clearInterval(id);
    }, [auth.loggedIn, listMaps]);

    const handleMapChange = (updated: Map) => {
        setMaps((prev) => prev.map((m) => (m.id === updated.id ? updated : m)));
    };

    return (
        <>
            <TopographNavbar />
            <br />
            {!auth.loggedIn && (
                <div style={{ marginLeft: "1rem" }}>You are not logged in! Log in to see your maps.</div>
            )}
            <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 900: 2, 1400: 3 }}>
                <Masonry gutter="20px">
                    {maps.map((m) => (
                        <Card key={m.id} style={{ width: "100%" }}>
                            <MapOverview map={m} card onChange={handleMapChange} />
                        </Card>
                    ))}
                </Masonry>
            </ResponsiveMasonry>
        </>
    );
}
